import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import api from "../../services/api";

// HAPPYCAP_PRIVATE_PHOTO_LIGHTBOX_V1
const PrivateChatPhoto = ({ message }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const photoId = String(message.id ?? "")
    .match(/^photo_([1-9][0-9]*)$/)?.[1];

  useEffect(() => {
    let active = true;
    let objectUrl = null;

    setImageUrl(null);
    setError(false);
    setIsOpen(false);

    if (!photoId) {
      setError(true);
      return () => {
        active = false;
      };
    }

    const loadPhoto = async () => {
      try {
        const response = await api.get(
          `/chat/fotos/${photoId}/`,
          { responseType: "blob" }
        );

        if (!active) return;

        if (
          !response.data ||
          !response.data.type.startsWith("image/")
        ) {
          throw new Error("Respuesta de imagen no válida");
        }

        objectUrl = URL.createObjectURL(response.data);
        setImageUrl(objectUrl);
      } catch (err) {
        if (active) {
          setError(true);
          console.warn(
            "No se pudo cargar la fotografía privada",
            err
          );
        }
      }
    };

    loadPhoto();

    return () => {
      active = false;

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [photoId]);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [isOpen]);

  if (error) {
    return (
      <p className="text-sm text-slate-500">
        Fotografía no disponible o eliminada.
      </p>
    );
  }

  if (!imageUrl) {
    return (
      <p className="text-sm text-slate-500">
        Cargando fotografía...
      </p>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="block max-w-full cursor-zoom-in rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Ampliar fotografía privada"
      >
        <img
          src={imageUrl}
          alt="Fotografía privada del chat"
          className="max-h-80 w-auto max-w-full rounded-lg object-contain"
          loading="lazy"
        />
      </button>

      {isOpen &&
        createPortal(
          <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 p-4"
            role="dialog"
            aria-modal="true"
            aria-label="Fotografía ampliada"
            onClick={() => setIsOpen(false)}
          >
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-white/20 text-3xl text-white hover:bg-white/30 focus:outline-none focus:ring-2 focus:ring-white"
              aria-label="Cerrar fotografía"
            >
              ×
            </button>

            <img
              src={imageUrl}
              alt="Fotografía privada ampliada"
              className="max-h-[90vh] max-w-[95vw] object-contain"
              onClick={(event) => event.stopPropagation()}
            />
          </div>,
          document.body
        )}
    </>
  );
};

export default PrivateChatPhoto;
